import { buttonBase } from "./layoutStyles";

export const controlePatientListStyle = {
    padding: "8px",
    overflowY: "auto",
    maxHeight: "calc(100vh - 360px)",
};

export const controlePatientItemStyle = {
    minWidth: 0,
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "10px",
    border: 0,
    borderRadius: "8px",
    padding: "10px",
    background: "transparent",
    textAlign: "left",
    cursor: "pointer",
};

export const controlePatientEditButtonStyle = {
    width: "30px",
    height: "30px",
    border: "1px solid #cbd5e1",
    borderRadius: "7px",
    background: "white",
    color: "#475569",
    fontSize: "13px",
    fontWeight: 900,
    cursor: "pointer",
    flexShrink: 0,
    transition: "opacity 0.16s ease, border-color 0.16s ease, color 0.16s ease",
};

export const controlePatientCountStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "42px",
    height: "24px",
    borderRadius: "999px",
    background: "#f8fafc",
    color: "#475569",
    border: "1px solid #e2e8f0",
    fontSize: "11px",
    fontWeight: 900,
    flexShrink: 0,
};

export const controlePatientPdaPanelStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "12px",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #bfdbfe",
    background: "#eff6ff",
    overflowWrap: "anywhere",
};

export const controlePatientPdaEditorStyle = {
    display: "grid",
    gap: "8px",
    minWidth: 0,
};

export const controlePatientPdaHistoryStyle = {
    display: "grid",
    alignContent: "start",
    gap: "8px",
    minWidth: 0,
};

export const controlePatientPdaLabelStyle = {
    color: "#1e3a8a",
    fontSize: "12px",
    fontWeight: 950,
    textTransform: "uppercase",
};

export const controlePatientPdaEmptyStyle = {
    padding: "11px",
    borderRadius: "8px",
    border: "1px dashed #bfdbfe",
    background: "rgba(255, 255, 255, 0.7)",
    color: "#64748b",
    fontSize: "13px",
};

export const controlePatientPdaHistoryItemStyle = {
    display: "grid",
    gap: "4px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #dbeafe",
    background: "white",
};

export const lastDossierButtonStyle = {
    ...buttonBase,
    height: "32px",
    padding: "0 12px",
    background: "white",
    borderColor: "#bae6fd",
    color: "#075985",
    fontWeight: 900,
};

export const controlePdaSaveRemarkButtonStyle = {
    ...buttonBase,
    background: "#0f172a",
    borderColor: "#0f172a",
    color: "white",
    fontWeight: 950,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.18)",
};

export const lastDossierStatusStyle = validated => ({
    display: "inline-flex",
    alignItems: "center",
    minHeight: "24px",
    padding: "0 8px",
    borderRadius: "999px",
    background: validated ? "#dcfce7" : "#fee2e2",
    color: validated ? "#166534" : "#991b1b",
    fontSize: "11px",
    fontWeight: 950,
});

export const instructionInfoBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "18px",
    height: "18px",
    borderRadius: "999px",
    background: "#e0f2fe",
    color: "#075985",
    border: "1px solid #bae6fd",
    fontSize: "12px",
    fontWeight: 950,
    flexShrink: 0,
    cursor: "help",
    padding: 0,
    lineHeight: 1,
};

export const instructionTooltipStyle = {
    position: "absolute",
    right: 0,
    top: "calc(100% + 8px)",
    zIndex: 1300,
    width: "min(320px, calc(100vw - 48px))",
    maxWidth: "320px",
    padding: "10px 12px",
    borderRadius: "8px",
    background: "#0f172a",
    color: "white",
    boxShadow: "0 16px 36px rgba(15, 23, 42, 0.26)",
    fontSize: "12px",
    fontWeight: 750,
    lineHeight: 1.45,
    pointerEvents: "none",
    whiteSpace: "normal",
};

export const emptyPatientTextStyle = {
    margin: 0,
    padding: "12px",
    color: "#94a3b8",
    fontSize: "13px",
};

export const blockingPatientSummaryStyle = {
    display: "grid",
    gap: "12px",
    padding: "14px",
    background: "white",
    border: "1px solid #fecaca",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
};

export const blockingPatientRowsStyle = {
    display: "grid",
    border: "1px solid #fecaca",
    borderRadius: "8px",
    overflow: "hidden",
    background: "white",
};

export const blockingPatientHeaderRowStyle = withStatus => ({
    display: "grid",
    gridTemplateColumns: withStatus ? "minmax(180px, 260px) minmax(260px, 1fr) 150px" : "minmax(180px, 260px) minmax(260px, 1fr)",
    gap: "8px",
    padding: "8px 10px",
    background: "#fff7ed",
    borderBottom: "1px solid #fed7aa",
    color: "#9a3412",
    fontSize: "12px",
    fontWeight: 950,
});

export const blockingPatientIssueStyle = withStatus => ({
    display: "grid",
    gridTemplateColumns: withStatus ? "minmax(180px, 260px) minmax(260px, 1fr) 150px" : "minmax(180px, 260px) minmax(260px, 1fr)",
    gap: "8px",
    alignItems: "center",
    padding: "9px 10px",
    background: "#fffaf5",
    borderBottom: "1px solid #ffedd5",
});
